/**
 * Format a date string to a localized date/time string
 */
export const formatDate = (iso?: string): string => {
  if (!iso) return '—';
  return new Date(iso).toLocaleString();
};

/**
 * Format file size in bytes to human-readable format
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
};

/**
 * Format minutes to human-readable format (e.g., "2h 30m" or "45m" or "30s")
 */
export const formatMinutes = (minutes: number): string => {
  if (minutes === 0) return '0m';
  
  const totalSeconds = Math.round(minutes * 60);
  const hours = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  
  if (hours > 0) {
    if (mins > 0) {
      return `${hours}h ${mins}m`;
    }
    return `${hours}h`;
  } else if (mins > 0) {
    return `${mins}m`;
  } else {
    return `${secs}s`;
  }
};

/**
 * Format seconds to human-readable format (e.g., "2h 30m" or "45m" or "30s")
 */
export const formatSeconds = (seconds: number): string => {
  return formatMinutes(seconds / 60);
};

/**
 * Breadcrumb item type
 */
export interface BreadcrumbItem {
  id: string;
  name: string;
  type: 'folder';
  path?: string;
}

/**
 * Build breadcrumbs from a folder path
 */
export const buildBreadcrumbs = (folderPath: string): BreadcrumbItem[] => {
  const parts = folderPath.split('/').filter(Boolean);
  const crumbs: BreadcrumbItem[] = [
    { id: 'root', name: 'All Files', type: 'folder' },
  ];
  
  let currentPath = '';
  parts.forEach((part) => {
    currentPath = currentPath ? `${currentPath}/${part}` : part;
    crumbs.push({
      id: `folder-${currentPath}`,
      name: part,
      type: 'folder',
      path: currentPath,
    });
  });
  
  return crumbs;
};

